<div class="alert alert-warning wrapper m-t-0 m-b-10" role="alert">
  <i class="fa fa-lg fa-exclamation-circle"></i>
  <p>
    For privacy, whenever possible a unique email address and mobile number is required for each vendor.
  </p>
</div>
